import { GameVars } from "../../GameVars";

export class GoldContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);
 
        this.x = 662;
        this.y = 50 * GameVars.scaleY;

        this.scaleY = GameVars.scaleY;

        const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tab_coin_balance");  
        background.setScale(1.35);
        this.add(background);

        const goldLabel = new Phaser.GameObjects.Text(scene, 25, -6, GameVars.formatNumber(GameVars.gameData.gold), {fontFamily: "AlmendraBold", color: "#663227", fontSize: "42px"});
        goldLabel.setOrigin(1, .5);
        this.add(goldLabel);

        if (goldLabel.width > 85) {
            goldLabel.setScale(85 / goldLabel.width);
        }
    }
}
